module.exports = __webpack_public_path__ + "static/p7-356e1a2f238a46636bf0adff74374e1f.jpg";